import { apiComun } from "../Utils/RutasApi";
import Http from "./Http";
import { trackPromise } from "react-promise-tracker";

export async function ObtengaListaPaises() {
  const url = apiComun.ObtengaPaises;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };
  const PaisesOrdenados = [...resultado.data].sort((a, b) =>
    a.nombrePais > b.nombrePais ? 1 : -1
  );
  return PaisesOrdenados;
}

export async function ObtengaGeneros() {
  const url = apiComun.ObtengaGeneros;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

export async function ObtengaTiposPersona() {
  const url = apiComun.ObtengaTiposPersona;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

export async function ObtengaTiposDocumentos() {
  const url = apiComun.ObtengaTiposDocumento;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

export async function ValidarSubidaDeDocumento(ListaDocumentos: any) {
  const url = apiComun.ValidarDocumentos;
  let resultado = await trackPromise(Http.post<any>(url, ListaDocumentos));
  return resultado.status === 200 ? resultado.data : null;
}

export async function ObtengaTiposReporteCrediticio() {
  const url = apiComun.ObtengaTiposReporteCrediticio;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };
  return resultado.data;
}

export async function ObtengaTiposAutorizacion() {
  const url = apiComun.ObtengaTiposAutorizacion;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

async function ObtengaTiposSolicitudCambio() {
  const url = apiComun.ObtengaTiposSolicitudCambio;
  let resultado = await trackPromise(Http.get(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

async function ObtengaEntidadesRelacionadas() {
  const url = apiComun.ObtengaEntidadesRelacionadas;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

async function ObtengaEntidadesPrincipalYRelacionadas() {
  const url = apiComun.ObtengaEntidadesPrincipalYRelacionadas;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

async function ObtengaTiposMotivoLiquidacion() {
  const url = apiComun.ObtengaTiposMotivoLiquidacion;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

async function ObtengaTiposOperacion() {
  const url = apiComun.ObtengaTiposOperacion;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };

  return resultado.data;
}

async function ObtengaContactosCic() {
  const url = apiComun.ObtengaContactosCic;
  let resultado = await trackPromise(Http.get<any>(url));

  return resultado.data;
}

const ServicioComun = {
  ObtengaGeneros,
  ObtengaListaPaises,
  ValidarSubidaDeDocumento,
  ObtengaTiposPersona,
  ObtengaTiposDocumentos,
  ObtengaTiposReporteCrediticio,
  ObtengaTiposAutorizacion,
  ObtengaTiposSolicitudCambio,
  ObtengaEntidadesRelacionadas,
  ObtengaEntidadesPrincipalYRelacionadas,
  ObtengaTiposMotivoLiquidacion,
  ObtengaTiposOperacion,
  ObtengaContactosCic
};

export default ServicioComun;
